const CryptoKey = "NxVetKey";

/**
 * 錯誤訊息對應
 */
const RTN_MSG = {
  100000: "成功",
  900000: "發生錯誤",
  100100: "登入成功",
  100101: "帳號密碼錯誤",
  100102: "沒有可以驗證的服務，請檢查網路連線",
  100103: "未登入",
  100104: "需要網路連線",
  100105: "缺少必要參數",
  100106: "登入帳號沒有可用的診所",
  100107: "登入使用者資料錯誤",
  100108: "無存取該資料庫的權限",
  100109: "查無用戶資訊",
  100404: "找不到可以操作的資源",
  200001: "飼主 UserID 有誤",
  200002: "缺少查詢品種條件",
  200003: "寵物 petID 有誤",
  200004: "飼主電話重複",
  200005: "使用者已經註冊, Email 重複",
  200006: "註冊失敗，員工數已達上限",
  200007: "雲端儲存空間額度已滿",
};

const PET_STATUS_LIST = [
  {
    _id: "0",
    name: "Normal",
    nametc: "正常",
  },
  {
    _id: "1",
    name: "Abandoned",
    nametc: "棄養",
  },
  {
    _id: "2",
    name: "Lost",
    nametc: "走失",
  },
  {
    _id: "5",
    name: "Adoption",
    nametc: "送養",
  },
  {
    _id: "9",
    name: "Death",
    nametc: "歿",
  },
];

const PET_LIGATION_LIST = [
  {
    _id: "/ligation/Neutered",
    name: "Neutered",
    nametc: "已節育",
  },
  {
    _id: "/ligation/Spayed",
    name: "Spayed",
    nametc: "已節育",
  },
  {
    _id: "/ligation/Castrated",
    name: "Castrated",
    nametc: "已節育",
  },
  {
    _id: "/ligation/Intact",
    name: "Intact",
    nametc: "尚未節育",
  },
  {
    _id: "/ligation/OHE",
    name: "OHE",
    nametc: "已節育",
  },
];

const PET_GENDER_LIST = [
  {
    _id: "/gender/Male",
    name: "Male",
    nametc: "公",
  },
  {
    _id: "/gender/Female",
    name: "Female",
    nametc: "母",
  },
];

const RECORD_STATUS = {
  CHECK_IN: 0,
  INSPECTED: 10,
  DISPENSED: 20,
  CHECK_OUT: 90,
};

const IN_HOSPITAL_STATUS = {
  CHECK_IN: 0,
  CHECK_OUT: 90,
};

const ARCHIVE_STATUS = {
  waiting: -1,
  undone: 0,
  done: 10,
};

const EXECUTION_STATUS = {
  none: 0,
  unrequested: 10,
  requested: 20,
  done: 30,
};

const VERIFY_STATUS = {
  APPLY: 0,
  VERIFIED: 10,
  CANCEL: 90,
};

const ROLE_ADMIN_PREFIX = "/role/admin";

export {
  RTN_MSG,
  CryptoKey,
  PET_STATUS_LIST,
  PET_LIGATION_LIST,
  PET_GENDER_LIST,
  RECORD_STATUS,
  IN_HOSPITAL_STATUS,
  ARCHIVE_STATUS,
  EXECUTION_STATUS,
  VERIFY_STATUS,
  ROLE_ADMIN_PREFIX,
};
